import 'powerbi-client';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { LicenseManager } from 'ag-grid-enterprise';
import { environment } from './environments/environment';
import { initGtmContainer } from './helpers/gtm-loader';
import { isImpersonating } from './helpers/impersonation-token';

// Before bootstrap: the GTM container records the landing URL when it loads, and
// this bundle is large enough that a guard redirect can otherwise get there first.
// Staff signed in as a customer must not show up in the customer's analytics, so no container at all.
if (!isImpersonating()) {
  initGtmContainer();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));

LicenseManager.setLicenseKey(environment.agGridLicenseKey);
